// Centralized API client using ofetch
import { ofetch, type FetchOptions } from 'ofetch';

// Retry transient server errors (502/503/504) that occur during the
// 1–2 s window of the supervisor restarting the Node process.
const RETRY_STATUSES = new Set([502, 503, 504, 0]); // 0 = network/CORS

const baseFetch = ofetch.create({
  baseURL: '/api',
  credentials: 'include',
  retry: 2,
  retryDelay: 400, // 400ms, 800ms — covers the 1s restart window
  retryStatusCodes: [...RETRY_STATUSES],
  timeout: 15000,
  onResponseError({ response }) {
    if (response.status === 401) {
      // emit logout event — handled by auth store
      window.dispatchEvent(new CustomEvent('umail24:unauthorized'));
    }
  },
});

export interface ApiEnvelope<T> {
  ok: boolean;
  data?: T;
  error?: string;
  code?: string;
}

type JsonOpts = FetchOptions<'json'>;

export const api = {
  get: <T>(url: string, opts?: JsonOpts) =>
    baseFetch<ApiEnvelope<T>>(url, { method: 'GET', ...opts }),
  post: <T>(url: string, body?: BodyInit | Record<string, any> | null, opts?: JsonOpts) =>
    baseFetch<ApiEnvelope<T>>(url, { method: 'POST', body, ...opts }),
  patch: <T>(url: string, body?: BodyInit | Record<string, any> | null, opts?: JsonOpts) =>
    baseFetch<ApiEnvelope<T>>(url, { method: 'PATCH', body, ...opts }),
  del: <T>(url: string, opts?: JsonOpts) =>
    baseFetch<ApiEnvelope<T>>(url, { method: 'DELETE', ...opts }),
};